import { Router } from 'app/classes';
export class OrgSwitchConfirmController implements ng.IController {

    public static $inject = [
        '$scope',
        '$document',
        '$CurrentUser',
        '$IdentityResource',
        'org',
        'close',
        '$Router',
    ];

    public close: () => void;
    public password: string;
    public error: boolean = false;

    constructor(private $scope,
                private $document,
                private $CurrentUser,
                private $IdentityResource,
                private org,
                close,
                private $Router: Router) {

        this.close = () => {
            this.password = null;
            close();
        };

        $document.on('keydown', this.escHandler);

        $scope.$on('$destroy', () => {
            $document.off('keydown', this.escHandler);
        });
    }

    public confirm() {
        const payload = {
            'grant_type': 'change_active_organization',
            'password': this.password,
            'client_id': this.org.id
        };
        // set error to false in case this is not first confirm
        // and need to redisplay error message.
        this.error = false;
        this.$IdentityResource.post('token/', [], payload)
            .then((res) => {
                this.$CurrentUser.setToken(res.access_token);
                // load new route
                this.$Router.goto('/launchpad/');
                // reload to refresh blue bar
                window.location.reload();
            })
            .catch((err) => {
                this.error = true;
                this.$scope.$evalAsync();
            });
    }

    public escHandler = (event) => {
        if (event.keyCode === 27) {
            this.close();
        }
    }
}
